// import React, { useState, useEffect } from "react";
// import { getAllCategories } from "../lib/firebase/category/read_server";
// import { Link } from "react-router-dom";

// export default function CategoriesPagelist() {
//     const [categories, setCategories] = useState([]);

//     useEffect(() => {
//         async function fetchCategories() {
//             const fetchedCategories = await getAllCategories();
//             setCategories(fetchedCategories);
//         }
//         fetchCategories();
//     }, []);

//     if (!categories.length) {
//         return <div className="text-center mt-5">Loading Categories...</div>;
//     }

//     return (
//         <main className="container mt-4">
//             <h2 className="fw-bold mb-4 text-center">All Categories</h2>
//             <div className="row">
//                 {categories.map((category, key) => (
//                     <div key={key} className="col-md-3 mb-4">
//                         <CategoryCard category={category} />
//                     </div>
//                 ))}
//             </div>
//         </main>
//     );
// }

// function CategoryCard({ category }) {
//     return (
//         <Link to={`/categorie/${category?.id}`} className="text-decoration-none">
//             <div className="card text-center p-3 shadow-sm border-0">
//                 <img
//                     className="rounded-circle mx-auto d-block"
//                     src={category?.iconURL}
//                     alt="Category"
//                     width="100"
//                     height="100"
//                 />
//                 <h5 className="mt-3 fw-bold text-dark">{category?.name}</h5>
//             </div>
//         </Link>
//     );
// }

import React, { useState, useEffect, useRef } from "react";
import { getAllCategories } from "../lib/firebase/category/read_server";
import { Link } from "react-router-dom";
import "../css/categories/CategoriesPageList.css"; // Create this CSS file

export default function CategoriesPageList() {
  const [categories, setCategories] = useState([]);
  const cursorRef = useRef(null);

  useEffect(() => {
    // Fetch categories
    async function fetchCategories() {
      const fetchedCategories = await getAllCategories();
      setCategories(fetchedCategories);
    }
    fetchCategories();

    // Cursor animation
    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;
    const speed = 0.01;

    function animate() {
      if (cursorRef.current) {
        let distX = mouseX - cursorX;
        let distY = mouseY - cursorY;

        cursorX = cursorX + distX * speed;
        cursorY = cursorY + distY * speed;

        cursorRef.current.style.left = `${cursorX}px`;
        cursorRef.current.style.top = `${cursorY}px`;

        requestAnimationFrame(animate);
      }
    }

    animate();

    function handleMouseMove(event) {
      mouseX = event.pageX;
      mouseY = event.pageY;
    }

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  if (!categories.length) {
    return <div className="text-center mt-5">Loading Categories...</div>;
  }

  return (
    <main className="container mt-4 position-relative">
      <div className="bg__gradient" ref={cursorRef}></div>
      <h2 className="fw-bold mb-4 text-center">All Categories</h2>
      <div className="row">
        {categories.map((category, key) => (
          <div
            key={key}
            className="col-md-6 col-lg-3 mb-4"
          >
            <CategoryCard category={category} />
          </div>
        ))}
      </div>
    </main>
  );
}

function CategoryCard({ category }) {
  const cardRef = useRef(null);

  useEffect(() => {
    // Simple tilt effect without jQuery.tilt
    const card = cardRef.current;

    const handleMouseMove = (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      const rotateX = (y - centerY) / 20;
      const rotateY = (centerX - x) / 20;

      card.style.transform = `perspective(1500px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.01)`;
    };

    const handleMouseLeave = () => {
      card.style.transform =
        "perspective(1500px) rotateX(0deg) rotateY(0deg) scale(1)";
    };

    card.addEventListener("mousemove", handleMouseMove);
    card.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      card.removeEventListener("mousemove", handleMouseMove);
      card.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <Link to={`/categorie/${category?.id}`} className="text-decoration-none">
      <div ref={cardRef} className="card text-center p-3 border-0 categorie-card">
        <img
          className="rounded-circle mx-auto d-block"
          src={category?.iconURL}
          alt="Category"
          width="100"
          height="100"
        />
        <h5 className="mt-3 fw-bold text-dark">{category?.name}</h5>
      </div>
    </Link>
  );
}
